import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { NJSpinner } from "@engie-group/fluid-design-system-react";
import { AppShell } from "@/components/AppShell/AppShell";
import { useAuth } from "./useAuth";

/** Gates a route behind Okta auth; RBAC visibility (not authority) is decided by callers.
 * Wraps authenticated content in the shared `AppShell` (sidebar + topbar). */
export function ProtectedRoute({ children }: { children: ReactNode }) {
  const { authenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex h-dvh items-center justify-center">
        <NJSpinner aria-label="Loading" />
      </div>
    );
  }

  if (!authenticated) {
    return <Navigate to="/login" replace />;
  }

  return <AppShell>{children}</AppShell>;
}
